var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"OrganManage"}},[_c('organuser',{attrs:{"SplitProcessID":"00000000"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }